import axios from 'axios';

// In production React and API are on the same origin.
// In dev, package.json "proxy" forwards /api -> localhost:3001.
const API = axios.create({ baseURL: '/api' });

API.interceptors.request.use(cfg => {
  const token = localStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export default API;
